import React, { Component, createRef } from 'react';

import { Box, Button, Container, Dialog, DialogActions, DialogTitle, FormHelperText, Grid, IconButton, TextField } from '@mui/material';
import Modal from '@mui/material/Modal';
import CloseIcon from '@mui/icons-material/Close';
import { inject, observer } from 'mobx-react';
import Dropzone from 'react-dropzone';
import { flowRight as compose } from 'lodash';
import MaskedInput from 'react-text-mask';

import AxlDatePicker from '../../AxlMUIComponent/AxlDatePicker';
import DriverStepper from '../../components/drivers/DriverStepper';
import { validateField } from '../../constants/validationSchemas';
import { withRouter } from '../../providers';
import styles, * as S from './add-styles';

const PhoneMaskInput = React.forwardRef(function PhoneMaskInput(props, ref) {
  const { onChange, ...other } = props;
  return (
    <MaskedInput
      {...other}
      ref={(inputRef) => {
        if (inputRef) {
          ref(inputRef.inputElement);
        }
      }}
      mask={['+', '1', ' ', '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
      placeholderChar={'\u2000'}
      showMask={false}
      onChange={onChange}
    />
  );
});

class AddAccountInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataError: {},
      initDataError: {},
      confirmation: false,
      checking: false,
    };
  }

  componentDidMount() {
    const { store } = this.props;
    // init error
    const initDataError = {};
    for (let i = 0; i < this.accountInfoFields.length; i++) {
      this.checkError(this.accountInfoFields[i], 'init_');
    }

    this.setState({ initDataError });
  }

  validates = {
    first_name: ['notEmpty'],
    last_name: ['notEmpty'],
    phone_number: ['notEmpty', 'phone'],
    birthday: ['notEmpty'],
    driver_license: ['notEmpty'],
    background_document: ['notEmpty'],
    email: ['notEmpty', 'email'],
  };

  accountInfoFields = ['first_name', 'last_name', 'birthday', 'driver_license', 'phone_number', 'email', 'background_document'];

  checkError = (field, prefix) => {
    const { store } = this.props;
    const { driverData } = store.driverStore;
    if (!prefix) {
      const initErrorField = 'init_' + field + '_error';
      this.setState({ [initErrorField]: undefined });
    }

    const errorField = prefix ? prefix + field + '_error' : field + '_error';

    const validationRules = this.validates[field];

    if (!validationRules) return;
    const value = driverData[field];

    const result = validateField(field, value, validationRules);

    // process current error
    if (!result) this.setState({ [errorField]: undefined });
    else {
      this.setState({ [errorField]: result });
    }
  };

  handleClose = () => {
    const { store } = this.props;
    store.driverStore.clearDriverData();
    this.setState({ confirmation: true });
  };

  onTextFieldChange = (field) => (event) => {
    const { store } = this.props;

    store.driverStore.updateDriverData(field, event.target.value);
    const fieldValidates = this.validates[field];

    if (fieldValidates) {
      this.checkError(field);
    }
  };

  onDateFieldChange = (field) => (date) => {
    const { store } = this.props;

    let value = date;
    if (date.target?.value) {
      value = date.target.value;
    }

    store.driverStore.updateDriverData(field, value);
    const fieldValidates = this.validates[field];

    if (fieldValidates) {
      this.checkError(field);
    }
  };

  onUpload = (acceptedFiles) => {
    const { store } = this.props;
    store.driverStore.updateDriverData('background_document', acceptedFiles[0]);
    store.driverStore.updateDriverData('background_document_url', undefined);

    const fieldValidates = this.validates['background_document'];

    if (fieldValidates) {
      this.checkError('background_document');
    }
  };

  goNext = () => {
    const { history, store } = this.props;
    this.checkExist().then((resp) => {
      if (resp.status === 200 && !Object.values(resp.data).find((r) => !!r)) {
        store.driverStore.upload();
        store.driverStore.setStep(1);
        history.push('/drivers/add-vehicle');
      }
    });
  };

  getValue = (field, df) => (this.props.store.driverStore.driverData[field] ? this.props.store.driverStore.driverData[field] : df !== undefined ? df : '');

  closeDialog = () => {
    const { store } = this.props;
    const { driverStore } = store;
    driverStore.clearDriverData();
    this.setState({ confirmation: false });
  };

  closeAddModal = () => {
    const { history, store } = this.props;
    const { driverStore } = store;
    driverStore.clearDriverData();
    this.setState({ confirmation: false });
    history.replace('/drivers');
  };

  checkExist = (target) => {
    const { driverStore, userStore } = this.props.store;
    const { driverData } = driverStore;

    this.setState({ checking: true });
    return driverStore.checkExist().then((resp) => {
      if (resp.status === 200) {
        Object.keys(resp.data).forEach((k) => {
          if (resp.data[k]) {
            this.setState({ [k + '_error']: `${driverData[k]} is not available, please take another one.` });
          }
        });
      }

      this.setState({ checking: false });
      return resp;
    });
  };

  render() {
    const { store } = this.props;
    const { driverData } = store.driverStore;
    const hasError = this.accountInfoFields.find((field) => !!this.state[field + '_error'] || !!this.state['init_' + field + '_error']);
    const dropzoneRef = createRef();

    return (
      <Container sx={styles.root}>
        <Modal aria-labelledby="add-driver" aria-describedby="add-driver" open={true} onClose={this.handleClose} sx={styles.modal}>
          <Box sx={styles.paper}>
            <Dialog
              open={this.state.confirmation}
              onClose={this.closeDialog}
              maxWidth={'md'}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              sx={styles.confirmDialog}
            >
              <DialogTitle sx={styles.confirmDialogTitle} id="alert-dialog-title">
                <Box style={{ fontWeight: 'bold' }}>
                  Are you sure you want to leave?
                  <br />
                  The driver being created will not save.
                </Box>
              </DialogTitle>
              <DialogActions>
                <Box sx={{ width: '100%', justifyContent: 'space-between', display: 'flex', p: 1.25 }}>
                  <Button
                    variant="outlined"
                    onClick={this.closeDialog}
                    color="primary"
                    disableElevation
                    size='small'
                  >
                    Back
                  </Button>
                  <Button
                    variant="contained"
                    onClick={this.closeAddModal}
                    color="error"
                    autoFocus
                    disableElevation
                    size='small'
                  >
                    Leave
                  </Button>
                </Box>
              </DialogActions>
            </Dialog>
            <Grid container direction="row" justifyContent="space-between" alignItems="center">
              <Grid size={3}>
                <S.Title>{`Create New Driver`}</S.Title>
              </Grid>
              <Grid size={6}>
                <DriverStepper style={{ width: '100%' }} currentStep={0} />
              </Grid>
              <Grid size={3}>
                <Box bgcolor="background.paper" color="text.primary" p={2} position="absolute" top={0} right="0" zIndex="modal">
                  <IconButton onClick={this.handleClose} size="large">
                    <CloseIcon />
                  </IconButton>
                </Box>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid size={6}>
                <Box my={0.5}>
                  <Box fontFamily={'AvenirNext-Medium'} fontSize={17} color={'#4a4a4a'} fontWeight={500} mb={0.5}>
                    First Name
                  </Box>
                  <TextField
                    onChange={this.onTextFieldChange('first_name')}
                    error={!!this.state['first_name_error']}
                    helperText={this.state['first_name_error']}
                    value={this.getValue('first_name')}
                    placeholder="First Name"
                    variant="outlined"
                    size="small"
                    fullWidth
                    slotProps={{ formHelperText: { sx: { color: '#d0021b', fontWeight: 'bold' } } }}
                  />
                </Box>
              </Grid>
              <Grid size={6}>
                <Box my={0.5}>
                  <Box fontFamily={'AvenirNext-Medium'} fontSize={17} color={'#4a4a4a'} fontWeight={500} mb={0.5}>
                    Last Name
                  </Box>
                  <TextField
                    error={!!this.state['last_name_error']}
                    helperText={this.state['last_name_error']}
                    onChange={this.onTextFieldChange('last_name')}
                    value={this.getValue('last_name')}
                    placeholder="Last Name"
                    variant="outlined"
                    size="small"
                    fullWidth
                    slotProps={{ formHelperText: { sx: { color: '#d0021b', fontWeight: 'bold' } } }}
                  />
                </Box>
              </Grid>
              <Grid size={6}>
                <Box my={0.5}>
                  <Box fontFamily={'AvenirNext-Medium'} fontSize={17} color={'#4a4a4a'} fontWeight={500} mb={0.5}>
                    Date of Birth
                  </Box>
                  <AxlDatePicker
                    errorMessage={this.state['birthday_error']}
                    onChange={this.onDateFieldChange('birthday')}
                    format="MM/DD/YYYY"
                    value={this.getValue('birthday', null)}
                    placeholder="MM/DD/YYYY"
                  />
                </Box>
              </Grid>
              <Grid size={6}>
                <Box my={0.5}>
                  <Box fontFamily={'AvenirNext-Medium'} fontSize={17} color={'#4a4a4a'} fontWeight={500} mb={0.5}>
                    Driver License Number
                  </Box>
                  <TextField
                    value={this.getValue('driver_license')}
                    error={!!this.state['driver_license_error']}
                    helperText={this.state['driver_license_error']}
                    onChange={this.onTextFieldChange('driver_license')}
                    placeholder="Driver License Number"
                    variant="outlined"
                    size="small"
                    fullWidth
                    slotProps={{ formHelperText: { sx: { color: '#d0021b', fontWeight: 'bold' } } }}
                  />
                </Box>
              </Grid>
              <Grid size={6}>
                <Box my={0.5}>
                  <Box fontFamily={'AvenirNext-Medium'} fontSize={17} color={'#4a4a4a'} fontWeight={500} mb={0.5}>
                    Phone Number
                  </Box>
                  <TextField
                    placeholder="+1 (555) 495-3947"
                    error={!!this.state['phone_number_error']}
                    helperText={this.state['phone_number_error']}
                    value={this.getValue('phone_number')}
                    onChange={this.onTextFieldChange('phone_number')}
                    variant="outlined"
                    size="small"
                    fullWidth
                    slotProps={{
                      input: {
                        inputComponent: PhoneMaskInput,
                      },
                      formHelperText: { sx: { color: '#d0021b', fontWeight: 'bold' } },
                    }}
                  />
                </Box>
              </Grid>
              <Grid size={6}>
                <Box my={0.5}>
                  <Box fontFamily={'AvenirNext-Medium'} fontSize={17} color={'#4a4a4a'} fontWeight={500} mb={0.5}>
                    Email Address
                  </Box>
                  <TextField
                    error={!!this.state['email_error']}
                    helperText={this.state['email_error']}
                    value={this.getValue('email')}
                    onChange={this.onTextFieldChange('email')}
                    placeholder="Email Address"
                    variant="outlined"
                    size="small"
                    fullWidth
                    slotProps={{ formHelperText: { sx: { color: '#d0021b', fontWeight: 'bold' } } }}
                  />
                </Box>
              </Grid>
              <Grid size={6} style={{ paddingTop: '30px' }}>
                <Grid container direction="row" justifyContent="space-between" alignItems="center">
                  <Grid size={6}>
                    <span style={{ color: '#737273', fontSize: '13px' }}>Background Check</span>
                  </Grid>
                  <Grid size={6}>
                    <Dropzone ref={dropzoneRef} onDrop={this.onUpload}>
                      {({ getRootProps, getInputProps }) => (
                        <div {...getRootProps()}>
                          <input {...getInputProps()} />
                          <Button variant="outlined" sx={{ ...styles.uploadDocument, border: '1px solid #ccc' }}>
                            Upload Document
                          </Button>
                        </div>
                      )}
                    </Dropzone>
                  </Grid>
                  {driverData?.['background_document'] && (
                    <Grid size={12}>
                      <FormHelperText id="component-error-text">{driverData['background_document']['name']}</FormHelperText>
                    </Grid>
                  )}
                  {this.state['background_document_error'] && (
                    <Grid size={12}>
                      <FormHelperText>{this.state['background_document_error']}</FormHelperText>
                    </Grid>
                  )}
                </Grid>
              </Grid>
            </Grid>
            <br />
            <br />
            <br />
            <Grid container direction="row" justifyContent="flex-end" alignItems="center">
              <Grid>
                <Button
                  disabled={!!hasError || this.state.checking}
                  size="small"
                  disableElevation
                  variant="contained"
                  color="primary"
                  onClick={this.goNext}
                >
                  Next
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Modal>
      </Container>
    );
  }
}

const AddAccountInfoCompose = compose(withRouter, inject('store'), observer)(AddAccountInfo);

export default AddAccountInfoCompose;
